import { IApplicationState } from '../../types/redux';

export function getDeveloper(state: IApplicationState) {
  return state.developer;
}
